import React, { useEffect, useState, memo, useCallback } from "react";
import styled from "styled-components/macro";
import { ColDef, DataGrid } from "@material-ui/data-grid";
import { Button, IconButton, makeStyles, TextField } from "@material-ui/core";
import { MdEdit, MdPlaylistAdd, MdDelete, MdRefresh } from "react-icons/md";
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

interface GridTableProps {
  add?: () => void;
  refresh: () => void;
  remove?: (ids: string[]) => void;
  edit?: (id: string) => void;
  data: any[];
  columns: ColDef[];
  isLoading: boolean;
  searchProperty: string;
  selectedRowCallback?: (idx: number) => void;
  checkboxes?: boolean;
  height?: number;
  autoPageSize?: boolean;
}

const GridTable: React.FC<GridTableProps> = ({
  add,
  refresh,
  remove,
  edit,
  data,
  columns,
  isLoading,
  searchProperty,
  selectedRowCallback,
  checkboxes = true,
  height = 600,
  autoPageSize = false,
}) => {
  const classes = useStyles();
  const [selected, setSelected] = useState<any>([]);
  const [filteredRows, setFiltered] = useState(data);

  useEffect(() => {
    setFiltered(data);
  }, [data]);

  const selectedRow = (params: any) => {
    setSelected(params.rowIds);
    const arrIdx = Number(params.rowIds) - 1;
    selectedRowCallback && selectedRowCallback(arrIdx);
  };

  const onEdit = () => {
    if (selected.length === 1) {
      edit && edit(selected[0]);
    }
    setSelected([]);
  };

  const onRemove = () => {
    remove && remove(selected);
    setSelected([]);
  };

  const onAdd = () => {
    add && add();
  };
  const onRefresh = () => {
    refresh();
  };

  const search = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const searchWord = event.target.value;
      const newRows = data.filter((item: any) =>
        item[searchProperty]?.toLowerCase().includes(searchWord.toLowerCase())
      );
      setFiltered(newRows);
    },
    [data]
  );

  return (
    <Container>
      <ActionBar>
        <SearchField
          id="outlined-search"
          label="Поле за търсене"
          type="search"
          variant="outlined"
          onChange={search}
        />
        <div>
          <IconButton aria-label="Обнови" onClick={onRefresh}>
            <MdRefresh />
          </IconButton>
          {edit && (
            <Button
              disabled={selected?.length !== 1}
              variant="contained"
              color="default"
              className={classes.button}
              startIcon={<MdEdit />}
              onClick={onEdit}
            >
              Промени
            </Button>
          )}
          {add && (
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              startIcon={<MdPlaylistAdd />}
              onClick={onAdd}
            >
              Добави
            </Button>
          )}
          {remove && (
            <Button
              disabled={selected?.length === 0}
              variant="contained"
              color="secondary"
              className={classes.button}
              startIcon={<MdDelete />}
              onClick={onRemove}
            >
              Премахни
            </Button>
          )}
        </div>
      </ActionBar>
      <AllProductsTableContainer height={height}>
        <DataGrid
          rows={filteredRows}
          rowHeight={45}
          columns={columns}
          pageSize={10}
          checkboxSelection={checkboxes}
          onSelectionChange={selectedRow}
          loading={isLoading}
          autoPageSize={true}
        />
      </AllProductsTableContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const AllProductsTableContainer = styled.div<{ height: number }>`
  height: ${(props) => `${props.height}px`};
  width: 100%;
`;
const ActionBar = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  justify-content: space-between;
`;

const SearchField = styled(TextField)`
  width: 350px;
`;
export default memo(GridTable);
